import React from "react";
import HeadImg from "../../../assets/Api/Header/Bg.svg";

const Header = () => {
  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };
  return (
    <div className="relative flex h-[72vh] flex-col 2xl:h-[58vh]">
      <img
        src={HeadImg}
        alt="Header Background"
        className="absolute bottom-0 left-0 w-full object-cover"
      />
      <div className="flex flex-col items-center justify-center pt-5 min-[450px]:pt-14 relative z-10">
        <div className="text-center max-w-4xl px-8 md:px-10">
          <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
            Zapier Integeration
          </p>
          <h1 className="text-3xl md:text-[42px] font-semibold text-center mt-2 !leading-[1.25]">
            Automatically Find Verified Emails in Your Zapier Workflows
          </h1>
          <p className="sm:text-lg text-md text-gray-400 mb-5 mt-3">
            Enhance your Zaps by discovering and verifying emails to boost your
            outreach.
          </p>
          <div className="text-center w-full flex justify-center mb-4">
            <button
              onClick={handlenav}
              className="text-white bg-background mt-6 lg:mt-10 hover:bg-hover font-semibold p-3 rounded-md hover:text-white w-[220px]"
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
